import { useQuery } from 'react-query';
import apiFetch from 'react-scale/lib/api-fetch';

export const useFetchAuditCoverageForSquad = (managerId: string) => {
  return useQuery(
    [`auditCoverageForSquad`, managerId],
    () =>
      apiFetch(null, 'internal/expert-management/auditCoverageForSquad', {
        method: 'POST',
        body: { managerId },
      }).then(data => data?.data?.experts),
    {
      staleTime: 60 * 60 * 1000,
      enabled: !!managerId,
    },
  );
};
